<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li class="active">
                <span>Stats</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            {{$auth.user().profile.name}} - Team stats
          </h3>
          <small>Stats of users attached to your account</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row" style="margin-bottom: 25px">
        <div class="col-xs-12">
          <VueCtkDateTimePicker style="text-align: right" v-model="rangeDate" :range="options.range"
                                :only-date="options.onlyDate" :label="options.label" :format="options.format"
                                :formatted="'LL'" :right="true" :auto-close="true">
            <button type="button" class="btn btn-info text-center btn-outline"></button>
          </VueCtkDateTimePicker>

        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="hpanel">
            <div class="panel-body">
              <div class="stats-title pull-left">
                <h4>traffic</h4>
              </div>
              <div class="stats-icon pull-right">
                <i class="fa fa-4x fa-line-chart"></i>
              </div>
              <div class="clearfix"></div>
              <div class="m-t-xs">

                <div class="row">
                  <div class="col-xs-6" data-toggle="popover" data-content="Total number of daily connections">
                    <small class="stat-label">Connections</small>
                    <h4 class="text-success" v-if="Object.keys(globalStats).length">{{globalStats.login}} <i class="fas fa-sign-in-alt"></i></h4>
                  </div>
                  <div class="col-xs-6" style="">
                    <small class="stat-label">New Users</small>
                    <h4 class="text-info" v-if="Object.keys(globalStats).length">{{globalStats.users}} <i class="fa fa-users"></i></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="hpanel">
            <div class="panel-body">
              <div class="stats-title pull-left">
                <h4>Users activity</h4>
              </div>
              <div class="stats-icon pull-right">
                <i class="fas fa-4x fa-tachometer-alt"></i>
              </div>
              <div class="clearfix"></div>
              <div class="m-t-xs">

                <div class="row">
                  <div class="col-xs-6" style="">
                    <small class="stat-label">Searches</small>
                    <h4 v-if="Object.keys(globalStats).length" class="text-warning">{{globalStats.searches}} <i class="fa fa-search"></i></h4>
                  </div>
                  <div class="col-xs-6" style="">
                    <small class="stat-label">New Projects</small>
                    <h4 v-if="Object.keys(globalStats).length" class="text-danger">{{globalStats.projects}} <i class="fa fa-rocket"></i></h4>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="hpanel">
            <div class="panel-body">
              <div class="stats-title pull-left">
                <h4>Share</h4>
              </div>
              <div class="stats-icon pull-right">
                <i class="fa fa-4x fa-share-alt"></i>
              </div>
              <div class="clearfix"></div>
              <div class="m-t-xs">

                <div class="row">
                  <div class="col-xs-6" style="">
                    <small class="stat-label">Documents</small>
                    <h4 v-if="Object.keys(globalStats).length" class="text-primary">{{globalStats.shareDocument}} <i class="fa fa-clone"></i></h4>
                  </div>
                  <div class="col-xs-6" style="">
                    <small class="stat-label">Projects</small>
                    <h4 v-if="Object.keys(globalStats).length" class="text-primary-2">{{globalStats.shareProject}} <i class="fa fa-rocket"></i></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">

          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#tab-1" aria-expanded="true" style="" @click="currentTab = 'chart'">
                <i class="fas fa-pie-chart"></i> <span class="hidden-xs">Graphics</span>
              </a>
            </li>
            <li class="">
              <a data-toggle="tab" href="#tab-2" style="" aria-expanded="false" @click="currentTab = 'table'">
                <i class="fa fa-search"></i> <span class="hidden-xs">Detailed Table</span>
              </a>
            </li>
            <li class="" v-if="$auth.check('super_admin') || $auth.check('manager')">
              <a data-toggle="tab" href="#tab-3" style="" aria-expanded="false" @click="currentTab = 'brokers-io'">
                <i class="fa fa-chart-bar"></i> <span class="hidden-xs">Brokers OI stats</span>
              </a>
            </li>
            <li class="" v-if="$auth.check('super_admin') || $auth.check('manager')">
              <a data-toggle="tab" href="#tab-4" style="" aria-expanded="false" @click="currentTab = 'seekers-io'">
                <i class="fa fa-chart-bar"></i> <span class="hidden-xs">Seekers OI stats</span>
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="tab-1" class="tab-pane active">
              <div class="row">
                <div class="col-md-12">
                  <div class="hpanel">
                    <div class="panel-body" >
                      <user-activity ref="chart" style="height: 600px" v-if="rawData.projects" :rawData="rawData" :rangeDate="rangeDate"></user-activity>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div id="tab-2" class="tab-pane">
              <div class="row">
                <div class="col-md-12">
                  <div class="hpanel">
                    <div class="panel-body">
                      <users-stats ref="usersStats"></users-stats>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div id="tab-3" class="tab-pane" v-if="$auth.check('super_admin') || $auth.check('manager')">
              <div class="row">
                <div class="col-md-12">
                  <div class="hpanel">
                    <div class="panel-body">
                      <brokers-stats-io v-if="currentTab === 'brokers-io'"></brokers-stats-io>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div id="tab-4" class="tab-pane" v-if="$auth.check('super_admin') || $auth.check('manager')">
              <div class="row">
                <div class="col-md-12">
                  <div class="hpanel">
                    <div class="panel-body">
                      <seekers-stats-io v-if="currentTab === 'seekers-io'"></seekers-stats-io>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style >
  .datepicker-container-label {
    height: auto !important;
  }
</style>

<script>
import 'datatables.net-bs/css/dataTables.bootstrap.min.css'
import 'datatables/media/js/jquery.dataTables.min'
import 'datatables.net-bs/js/dataTables.bootstrap.min'
import 'datatables.net-buttons/js/dataTables.buttons'
import 'datatables.net-buttons/js/buttons.print.min'
import 'datatables.net-buttons/js/buttons.html5.min'

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import UsersStats from '../../components/stats/usersStats'
import UserActivityByProfile from '../../components/charts/UserActivityByProfile'
import UserActivity from '../../components/charts/UserActivity'
import BrokersStatsIo from '../../components/stats/brokersStatsIo'
import SeekersStatsIo from '../../components/stats/seekersStatsIo'

export default {
  components: {
    SeekersStatsIo,
    BrokersStatsIo,
    UsersStats,
    UserActivity,
    UserActivityByProfile,
    VueCtkDateTimePicker},
  name: 'Stats',
  data () {
    return {
      dataTable: null,
      users: [],
      rangeDate: null,
      currentTab: 'chart',
      options: {
        onlyDate: true,
        format: 'YYYY-MM-DD',
        range: true,
        label: 'Select date range',
        id: 'RangeDatePicker',
        locale: 'en'
      },
      rawData: [],
      globalStats: {},
      selectedUsers: []
    }
  },
  watch: {
    selectedUsers (val) {
      this.getResources()
    },
    rangeDate (val) {
      this.getResources()
    },
    currentTab (val) {
      if (val === 'chart') {
        this.selectedUsers = this.$refs.usersStats.getSelectedRows()
      }
    }
  },
  methods: {
    getResources () {
      this.axios.post('stats/team', {users: this.selectedUsers, rangeDate: this.rangeDate}).then((response) => {
        this.rawData = response.data.range
        this.globalStats = response.data.global
      })
    }
  },
  beforeMount () {
    this.rangeDate = {
      start: this.$moment().subtract(1, 'months'),
      end: this.$moment()
    }

    this.getResources()
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top'
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/stats/Stats.vue